// extracted by mini-css-extract-plugin
export default {"link":"MenuLink_link__kgin8","linkDestacado":"MenuLink_linkDestacado__cvw0M"};